// extracted by mini-css-extract-plugin
module.exports = {"accountVerification":"style-module__accountVerification___ZunqZ","text":"style-module__text___21Ua5","buttonWrapper":"style-module__buttonWrapper___kGIN2"};